import { useContext } from 'react';
import { useTracking } from '../../../shared/utilities/tagManager/tagManager.hook';
import { ExternalAutoFormContext } from '../../pages/mfExternalAutoForm.context';
import {
  TRACKING,
  TrackingCategory,
  TrackingEventName,
  TrackingEventsMap,
} from '../../tracking/tracking.constants';

export const useFormFooter = (): {
  trackTermsLink: () => void;
  trackPrivacyLink: () => void;
} => {
  const {
    leadIdState: [leadId],
  } = useContext(ExternalAutoFormContext);
  const { trackEvent } = useTracking();
  const trackLinkEvent = (eventName: string): void => {
    trackEvent({
      event: {
        event: TrackingEventName.EXTERNAL_AUTO_PAGE,
        category: TrackingCategory.EXTERNAL_AUTO_PAGE,
        ...TrackingEventsMap[eventName],
        value: '',
      },
      extraInfo: {
        leadId,
      },
    });
  };
  return {
    trackTermsLink: (): void => trackLinkEvent(TRACKING.EVENTS.TERMS_LINK),
    trackPrivacyLink: (): void => trackLinkEvent(TRACKING.EVENTS.PRIVACY_LINK),
  };
};
